(function () {
  var sections = document.querySelectorAll('.section-store-list-zen');
  sections.forEach(function (section) {
    var sectionId = section.getAttribute('data-section-id');
    if (!sectionId) return;

    var wrapper = document.getElementById('shopify-section-' + sectionId);
    if (!wrapper) wrapper = section;

    var panelsSection = wrapper.querySelector('[data-panels-section]');
    var noResults = wrapper.querySelector('[data-no-results]');
    var searchInput = wrapper.querySelector('[data-store-search]');
    var searchBtn = wrapper.querySelector('[data-search-btn]');
    var searchResults = wrapper.querySelector('[data-search-results]');
    var searchHeading = wrapper.querySelector('[data-search-heading]');
    var searchGrid = wrapper.querySelector('[data-search-grid]');

    /* 1. Update panel headings */
    var panels = wrapper.querySelectorAll('[data-state-panel]');
    panels.forEach(function (panel) {
      var heading = panel.querySelector('[data-panel-heading]');
      var stateName = panel.getAttribute('data-state-name');
      if (heading) {
        heading.textContent = 'Zen Diamond \u2013 In ' + stateName;
      }
    });

    /* 2. State card click — toggle active + show/hide panels */
    var stateButtons = wrapper.querySelectorAll('[data-state-card]');
    var storeCards = wrapper.querySelectorAll('[data-store-card]');

    function activateState(stateId) {
      stateButtons.forEach(function (btn) {
        btn.classList.toggle(
          'section-store-list-zen__card--active',
          btn.getAttribute('data-state-card') === stateId
        );
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-visible', panel.getAttribute('data-state-panel') === stateId);
      });
      if (noResults) noResults.classList.remove('is-visible');
      storeCards.forEach(function (card) {
        card.style.display = '';
      });
    }

    /* Remove active class from all state tabs */
    function deactivateAllTabs() {
      stateButtons.forEach(function (btn) {
        btn.classList.remove('section-store-list-zen__card--active');
      });
    }

    /* Show normal state-tab view, hide search results, activate first tab */
    function showStateView() {
      panelsSection.style.display = '';
      searchResults.style.display = 'none';
      searchGrid.innerHTML = '';

      if (stateButtons.length > 0) {
        activateState(stateButtons[0].getAttribute('data-state-card'));
      }
    }

    /* Show search results, deactivate tabs, hide panels */
    function showSearchView(query) {
      deactivateAllTabs();
      panelsSection.style.display = 'none';
      searchGrid.innerHTML = '';

      var matchCount = 0;
      storeCards.forEach(function (card) {
        var pincode = card.getAttribute('data-pincode') || '';
        if (pincode.indexOf(query) !== -1) {
          matchCount++;
          var clone = card.cloneNode(true);
          searchGrid.appendChild(clone);
        }
      });

      if (searchHeading) {
        searchHeading.textContent = 'Zen Diamond \u2013 In \u201C' + query + '\u201D';
      }

      if (matchCount > 0) {
        searchResults.style.display = '';
        if (noResults) noResults.classList.remove('is-visible');
      } else {
        searchResults.style.display = 'none';
        panelsSection.style.display = '';
        panels.forEach(function (panel) {
          panel.classList.remove('is-visible');
        });
        if (noResults) noResults.classList.add('is-visible');
      }
    }

    /* Trigger search from input value */
    function performSearch() {
      var query = searchInput ? searchInput.value.trim() : '';
      if (!query) {
        showStateView();
        return;
      }
      showSearchView(query);
    }

    stateButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (searchInput) searchInput.value = '';
        panelsSection.style.display = '';
        searchResults.style.display = 'none';
        searchGrid.innerHTML = '';
        activateState(btn.getAttribute('data-state-card'));
      });
    });

    /* 3. Auto-select first state on page load */
    if (stateButtons.length > 0) {
      activateState(stateButtons[0].getAttribute('data-state-card'));
    }

    /* 4. Search button click */
    if (searchBtn) {
      searchBtn.addEventListener('click', performSearch);
    }

    /* 5. Enter key in search input */
    if (searchInput) {
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          performSearch();
        }
      });
    }
  });
})();
